import { render, staticRenderFns } from "./ArchitecturesList.vue?vue&type=template&id=5ffbcc38&scoped=true&"
import script from "./ArchitecturesList.vue?vue&type=script&lang=js&"
export * from "./ArchitecturesList.vue?vue&type=script&lang=js&"
import style0 from "./ArchitecturesList.vue?vue&type=style&index=0&id=5ffbcc38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffbcc38",
  null
  
)

export default component.exports